






















































































import { computed, defineComponent, ref, PropType, toRefs } from '@vue/composition-api';
import { ProductPreviewText } from '../hook';
import { ProductItem } from '@tt4b/ttam-enums';
import { debounce } from 'lodash-es';

const tabList = [
  {
    label: 'common_video',
    value: 'video',
  },
  {
    label: 'module_ad_type_catalogue_video',
    value: 'catalog_video',
  },
];
const name = 'ttam-catalogs-preview-middle';
export default defineComponent({
  components: {},
  props: {
    productList: {
      type: Array as PropType<ProductItem[]>,
      default: () => [],
    },
    curProduct: {
      type: Object as PropType<ProductItem>,
      default: null,
    },
    curTab: {
      type: String,
      default: '',
    },
    remote: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    message: {
      type: Object as PropType<ProductPreviewText>,
      default: null,
    },
    isSmartCreative: {
      type: Boolean,
      default: false,
    },
    isShowSelect: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const { curProduct, productList, curTab, isSmartCreative } = toRefs(props);

    const index = ref(0);

    const onQuery = debounce(val => emit('query', val), 200);
    const onChange = item => {
      emit('change', item);
    };
    const onSwitch = item => {
      emit('switch', item);
    };

    const selectTab = computed({
      get: () => {
        if (curTab.value) {
          return curTab.value;
        }
        return 'video';
      },
      set: val => {
        onSwitch(val);
      },
    });

    const isShowSelectProduct = computed(() => {
      if (!isSmartCreative.value) {
        return true;
      }
      return selectTab.value === 'catalog_video';
    });

    const select = computed({
      get: () => curProduct.value?.OuterID || '',
      set: (val: string) => {
        const selected = productList.value?.find?.(item => item.OuterID === val);
        if (selected) {
          onChange(selected);
        }
      },
    });

    const filterMethod = val => {
      onQuery(val);
    };

    const handleRefresh = () => {
      const isCurrent = productList.value?.[index.value]?.productID === curProduct.value?.productID;
      if (isCurrent) {
        index.value++;
      }
      if (index.value >= productList.value?.length) {
        index.value = 0;
      }
      onChange(productList.value[index.value++]);
    };

    const handleClickTab = e => {
      const value = e?.target?.dataset?.value;
      if (value) {
        selectTab.value = value;
      }
    };

    return {
      selectTab,
      name,
      select,
      isShowSelectProduct,
      handleRefresh,
      filterMethod,
      tabList,
      handleClickTab,
    };
  },
});
